









































































































import { Component, Vue, Watch, Provide } from 'vue-property-decorator';
import { timeFormat } from "@/utils/index";
import { nxExtenManageClient } from "@/api/index";
import { OperateNxteleReq, NxteleListReq } from "@/pbjs/xcommon/nxExtenManage_pb";
import { pagnition } from "@/utils/commonConfig";
import { setCommon, errorMsg, setPage } from "@/utils/request";

@Component({
  name: 'callSequence'
})
export default class callSequence extends Vue {
  @Provide() private isShowList:boolean = false;
  @Provide() private isShowOrder:boolean = false;
  @Provide() private activeName:string = "";
  @Provide() private activeListName:string = "listList";
  @Provide() private DialerList: any = []; // 下拉选项
  @Provide() private resultData: any = []; // list查询结果
  @Provide() private resultOrderData: any = []; // order查询结果
  @Provide() private submitType: number = 1; // 1：新增， 2：编辑 /生效 /失效
  @Provide() private addType: number = 1;
  @Provide() private searchType: number = 1;
  @Provide() private otpForm: any = {};
  @Provide() private data: any = {};
  @Provide() private ruleForm: any = {
    ticketaction: null,
    phoneobject: null,
    ticketorder: null
  };
  @Provide() private ruleFormOrder: any = {
    itemid: null,
    listid: null
  };
  @Provide() private ruleFormRules: any = {
    ticketaction: [{ required: true, message: '请选择', trigger: 'blur' }],
    phoneobject: [{ required: true, message: '请选择', trigger: 'blur' }],
    ticketorder: [{ required: true, message: '请选择', trigger: 'blur' }]
  }
  @Provide() private ruleFormOrderRules: any = {
    itemid: [{ required: true, message: '请选择', trigger: 'blur' }],
    listid: [{ required: true, message: '请输入', trigger: 'blur' }],
  }
  @Provide() private pagnition: any = pagnition;

  private created() {
    this.getList();
    this.getOrderList();
    this.getSelectListParam();
  }
  private showListFun(flag: boolean) {
    this.isShowList = flag;
    this.resetForm('ruleForm');
  }
  private showOrderFun(flag: boolean) {
    this.isShowOrder = flag;
    this.resetForm('ruleFormOrder');
  }
  private handleClick(tab:any) {
    this.addType = tab.name === "list" ? 1 : 2;
    this.submitType = 1;
    this.isShowList = true;
    this.isShowOrder = true;
    this.resetForm('ruleForm');
    this.resetForm('ruleFormOrder');
  }
  private handleListClick(tab:any) {
    if(tab.name === "listList"){
      this.searchType = 1;
      this.getList();
    } else {
      this.searchType = 2;
      this.getOrderList();
    }
    this.submitType = 1;
    this.isShowList = true;
    this.isShowOrder = true;
    this.resetForm('ruleForm');
    this.resetForm('ruleFormOrder');
  }
  // select list
  private async getSelectListParam() {
    const { getDialerListParam }: any = await import("@/request/callSequence");
    let res = await getDialerListParam();
    if (res) {
      this.DialerList = res;
    }
  }
  // 查询
  private async getList() {
    const { getDialerList }: any = await import("@/request/callSequence");
    let res = await getDialerList();
    if (res) {
      this.resultData = res.listList && this.getListFun(res.listList);
    }
  }
  private async getOrderList() {
    const { getDialerListOrder }: any = await import("@/request/callSequence");
    let res = await getDialerListOrder();
    if (res) {
      this.resultOrderData = res.listList && this.getOrderListFun(res.listList);
    }
  }
  // 查询数据
  private getListFun (data:any) {
    data.forEach((item:any)=>{
      item.dialer.cTime = item.dialer.ctime > 0 ? timeFormat(item.dialer.ctime) : "";
      item.dialer.uTime = item.dialer.utime > 0 ? timeFormat(item.dialer.utime) : "";
    })
    return data;
  }
  private getOrderListFun (data:any) {
    data.forEach((item:any)=>{
      item.dialerlistorder.cTime = item.dialerlistorder.ctime > 0 ? timeFormat(item.dialerlistorder.ctime) : "";
      item.dialerlistorder.uTime = item.dialerlistorder.utime > 0 ? timeFormat(item.dialerlistorder.utime) : "";
    })
    return data;
  }
  // 提交验证
  private submitForm() {
    let formName: string = "ruleForm";
    let ref: any = this.$refs[formName];
    ref.validate((valid: any) => {
      if (valid) {
        this.otpForm = this.ruleForm;
        this.otpForm.type = 1;
        if(this.submitType === 2){
          this.otpForm.id = this.data.dialer.id;
          this.otpForm.status = this.data.dialer.status;
          this.otpForm.opuid = this.data.dialer.opuid;
          this.otpForm.ctime = this.data.dialer.ctime;
          this.otpForm.utime = this.data.dialer.utime;
          this.otpForm.type = 2;
        }
        this.SaveDialer();
      } else {
        return false;
      }
    });
  }
  // 提交
  private async SaveDialer() {
    let otp = {detail: this.otpForm};
    const { saveDialer }: any = await import("@/request/callSequence");
    let res = await saveDialer(otp);
    if (res.commonout.code === 0) {
      this.$message({
        message: 'success',
        type: 'success'
      });
      this.activeListName = "listList";
      this.searchType = 1;
      this.resetForm("ruleForm");
      this.getList();
    }
  }
  // 顺序提交验证
  private submitOrderForm() {
    let formName: string = "ruleFormOrder";
    let ref: any = this.$refs[formName];
    ref.validate((valid: any) => {
      if (valid) {
        this.otpForm = this.ruleFormOrder;
        this.otpForm.type = this.addType;
        this.otpForm.type = 1;
        if(this.submitType === 2){
          this.otpForm.id = this.data.dialerlistorder.id;
          this.otpForm.status = this.data.dialerlistorder.status;
          this.otpForm.opuid = this.data.dialerlistorder.opuid;
          this.otpForm.ctime = this.data.dialerlistorder.ctime;
          this.otpForm.utime = this.data.dialerlistorder.utime;
          this.otpForm.type = 2;
        }
        this.getDialerListOrder();
      } else {
        return false;
      }
    });
  }
  // 顺序提交
  private async getDialerListOrder() {
    let otp = {detail: this.otpForm};
    const { saveDialerListOrder }: any = await import("@/request/callSequence");
    let res = await saveDialerListOrder(otp);
    if (res.commonout.code === 0) {
      this.$message({
        message: 'success',
        type: 'success'
      });
      this.activeListName = "listOrder";
      this.searchType = 2;
      this.resetForm("ruleFormOrder");
      this.getOrderList();
    }
  }
  // 生效失效，type:1list,2顺序; status:1生效，0失效 ;
  editStatus(row: any, type:number, status:number){
    this.otpForm = type === 1 ? row.dialer : row.dialerlistorder;
    this.otpForm.status = status;
    this.otpForm.type = 2;
    type === 1 ? this.SaveDialer() : this.getDialerListOrder();
  }
  // 列表编辑
  private editCombination(row: any) {
    this.submitType = 2;
    this.isShowList = true;
    this.isShowOrder = true;
    this.activeName = this.searchType === 1 ? "list" : "order";
    this.data = row;
    if(this.searchType === 1){
      let phoneobjects :any = [];
      row.dialer.phoneobjects.split(",").map((item: any) => {
        this.DialerList.phoneobjectList.map((item2: any) => {
          if (item == item2.value) {
            phoneobjects.push(item)
          }
        });
      });
      this.$nextTick(function () {
        this.ruleForm.ticketaction = row.dialer.ticketaction+"";
        this.ruleForm.phoneobject = phoneobjects;
        this.ruleForm.ticketorder = row.dialer.ticketorder+"";
      })
    } else {
      this.$nextTick(function () {
        this.ruleFormOrder.itemid = row.dialerlistorder.itemid+"";
        this.ruleFormOrder.listid = row.dialerlistorder.listid;
      })
    }
  }
  private resetForm(formName: string) {
    let ref: any = this.$refs[formName];
    if (ref) {
      ref.resetFields();
    }
  }
}
